import UIReadOnlyMixin from "../../UIReadOnlyMixin";

// @vue/component
export default {
  name: "UiJsonReadOnly",
  mixins: [
    UIReadOnlyMixin,
  ],
};
